export const RU_CODE = 'ru';
export const EN_CODE = 'en';
export const UZ_CODE = 'uz';
